import React from "react";
import { useRouteMatch } from "react-router-dom";
const NotFound = () => {
  let { path, url } = useRouteMatch();

  return <div>{`Uppsss, Ruta no encontrada ${path} ${url}`}</div>;
};

export default NotFound;
